import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { AuthContext } from "../context/AuthContext";
import FormatPrice from "../helper/FormatPrice";
import "./CartPage.css";
import CartItems from "./CartItems";
import { BsPaypal } from "react-icons/bs";
import { FaGooglePay } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { HiChatAlt2 } from "react-icons/hi";
import { MdEmail } from "react-icons/md";
import axios from "../helper/axios";

const CartPage = () => {
  const {
    cartItems,
    addToCart,
    removeFromCart,
    clearCart,
    removeFromCartList,
    temporaryCartItems,
    setTemporaryCartItems,
    fetchCartItems,
    totalAmount,
  } = useContext(CartContext);

  const { token } = useContext(AuthContext);

  const [totalAmnt, setTotalAmnt] = useState(0);

  const loggedInUser = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  // const loggedInUserId = localStorage.getItem("userId");

  useEffect(() => {
    if (token) {
      // Fetch cart items from the backend for logged-in users
      fetchCartItems();
    }
  }, [token]);

  // useEffect(() => {
  //   if (token) {
  //     let total = 0;
  //     cartItems.forEach((item) => {
  //       total += item.price * item.qty;
  //     });
  //     // console.log(total, "total");
  //     setTotalAmnt(total);
  //   } else {
  //     let total = 0;
  //     temporaryCartItems.forEach((item) => {
  //       total += item.price * item.quantity;
  //     });
  //     // console.log(total, "total");
  //     setTotalAmnt(total);
  //   }
  // }, [cartItems, temporaryCartItems, totalAmnt, token]);

  useEffect(() => {
    let total = 0;

    if (token && cartItems) {
      total = cartItems.reduce((acc, item) => acc + item.price * item.qty, 0);
    } else {
      total = temporaryCartItems.reduce(
        (acc, item) => acc + item.price * item.qty,
        0
      );
    }

    setTotalAmnt(total);
  }, [cartItems, temporaryCartItems, token, totalAmnt]);

  const navigate = useNavigate();

  const handleSecureCheckout = () => {
    if (token) {
      navigate("/checkout");
    } else {
      alert("Please login to continue");
      navigate("/login");
    }
  };
  const startShopping = () => {
    navigate("/");
  };

  const handleIncrementList = (itemId) => {
    const item = cartItems.find((item) => item.product_id === itemId);
    addToCart(item, userId);
    // console.log("item", item);
  };

  const handleDecrementList = async (itemId) => {
    const item = cartItems.find((item) => item.product_id === itemId);

    if (item && item.qty > 1) {
      const updatedQuantity = item.qty - 1;

      if (loggedInUser) {
        try {
          // Decrease the quantity by 1 and update the cart on the backend
          const newCart = {
            cart_id: item.cart_id,
            cart_qty: updatedQuantity,
          };

          // Call your update API here
          await axios.put("/update_item_in_cart", newCart);
          fetchCartItems();
          alert("Cart Quantity Decreased");
          removeFromCart(itemId, updatedQuantity); // Remove from cart context

          // setTotalAmnt(totalAmnt - item.price);// Update total amount
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  const handleDeleteItemList = (itemId) => {
    if (!token) {
      const updatedTempCartItems = temporaryCartItems.filter(
        (item) => item.cart_id !== itemId
      );
      setTemporaryCartItems([...updatedTempCartItems]);
    } else {
      removeFromCartList(itemId);
    }
  };

  return (
    <>
      {/* <section className="pb-5 mb-2">
        <div className="page-banner hero-container">
          <div className="banner-content">
            <h1>Cart</h1>
          </div>
        </div>
      </section> */}

      <section className="pb-5 mb-2">
        <div className="container pt-5">
          {cartItems.length == 0 && temporaryCartItems.length == 0 ? (
            <>
              <h1>Cart is Empty</h1>
              <p className="text-center">
                <button className="btn btn__primary" onClick={startShopping}>
                  Start Shopping
                </button>
              </p>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col-8">
                  {loggedInUser ? (
                    <>
                      <h4 className="mb-4">
                        Total Items in Cart : {cartItems.length}
                      </h4>
                      {cartItems.map((curElem, index) => (
                        <div className="row d-flex w-100" key={index}>
                          <div className="col-2">
                            <NavLink
                              to={`/singleproduct/${curElem.product_sku}`}
                              className="fw-bold my-2 link-dark"
                            >
                              <img
                                src={curElem.product_image.split(",")[0]}
                                className="w-100"
                              />
                            </NavLink>
                          </div>
                          <div className="col-7 mb-2">
                            <NavLink
                              to={`/singleproduct/${curElem.product_sku}`}
                              className="fw-bold my-2 link-dark"
                            >
                              {curElem.product_name} - {curElem.product_id}
                            </NavLink>
                            <p className="my-0 text-muted">
                              SKU: {curElem.product_sku}
                            </p>
                            <p className="my-0 text-muted">
                              {curElem.carat}K {curElem.metal_id_fk}
                            </p>
                            <p className="my-0">
                              Price : <FormatPrice price={curElem.price} />
                            </p>
                            <p className="my-2">Size / Length :</p>
                            <select name="size" id="size" className="p-2">
                              <option value="1">1.00</option>
                              <option value="2">2.00</option>
                              <option value="3">3.00</option>
                              <option value="4">4.00</option>
                              <option value="5">5.00</option>
                            </select>
                            <br />
                            <p className="fw-bold mt-2">
                              Made To Order.{" "}
                              <span className="fw-normal">
                                Estimated Ship Date: Friday, August 4th
                              </span>
                            </p>
                          </div>
                          <div className="col-2">
                            <div className="cart-item-price">
                              <span>
                                <b>
                                  <FormatPrice
                                    price={curElem.price * curElem.qty}
                                  />
                                </b>
                              </span>
                            </div>
                            <p className="mb-0">Quantitiy:</p>
                            <div className="cart-item-qty">
                              <div>
                                <button
                                  onClick={() =>
                                    handleDecrementList(curElem.product_id)
                                  }
                                >
                                  -
                                </button>
                                <h6>{curElem.qty}</h6>
                                <button
                                  onClick={() =>
                                    handleIncrementList(curElem.product_id)
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-1 text-right">
                            <div className="cart-item-delete1 text-end">
                              <button
                                className="border-0"
                                onClick={() =>
                                  handleDeleteItemList(curElem.cart_id)
                                }
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      <button
                        className="btn btn__primary mt-5"
                        onClick={clearCart}
                      >
                        Clear Cart
                      </button>
                      <p className="text-center">
                        <button className="btn" onClick={startShopping}>
                          Continue Shopping
                        </button>
                      </p>
                    </>
                  ) : (
                    <>
                      <h4 className="mb-4">
                        Total Items in Cart : {temporaryCartItems.length}
                      </h4>
                      {temporaryCartItems.map((curElem, index) => (
                        <>
                          <CartItems key={index} {...curElem} />
                        </>
                      ))}
                      <button
                        className="btn btn__primary mt-5"
                        onClick={clearCart}
                      >
                        Clear Cart
                      </button>
                      <p className="text-center">
                        <button className="btn" onClick={startShopping}>
                          Continue Shopping
                        </button>
                      </p>
                    </>
                  )}
                </div>
                <div className="col-4">
                  <div className="col-12 border border-secondary rounded px-2">
                    <h5 className="mt-3 mb-4 text-center fw-bold">
                      Order Summery
                    </h5>
                    <p className="fw-strong mt-3">Coupan Code</p>
                    <div className="input-group my-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Coupan Code"
                      />
                      <button
                        className="btn btn-secondary"
                        type="button"
                        id="button-addon2"
                      >
                        Apply
                      </button>
                    </div>
                    <hr className="my-4" />
                    <table className="table my-3 py-3">
                      <tbody>
                        <tr>
                          <td className="text-start">Merchandise Subtotal:</td>
                          <td className="text-end">
                            <FormatPrice price={totalAmount} />
                          </td>
                        </tr>
                        <tr>
                          <td className="text-start fw-bold">Order Total:</td>
                          <td className="text-end fw-bold">
                            <FormatPrice price={totalAmount} />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <button
                      className="btn btn-secondary w-100 p-3 my-2"
                      onClick={handleSecureCheckout}
                    >
                      SECURE CHECKOUT
                    </button>

                    <hr className="hr-text" data-content="EXPRESS CHECKOUT" />

                    <div className="d-flex flex-column text-center my-4">
                      <a href="#" className="link-dark">
                        <BsPaypal /> Paypal
                      </a>
                      <br />
                      <a href="#" className="link-dark">
                        <FaGooglePay /> Google Pay
                      </a>
                    </div>

                    <div className="contact my-4 d-flex justify-content-evenly align-items-center">
                      <a href="#" className="link-dark">
                        <FiPhoneCall /> 1234567890
                      </a>
                      <a href="#" className="link-dark">
                        <HiChatAlt2 /> Live Chat
                      </a>
                      <a href="mailto:maitriai@gmail.com" className="link-dark">
                        <MdEmail /> Email Us
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default CartPage;
